// extracted by mini-css-extract-plugin
export default {"toolbarCircle":"ThemeToggleControl_toolbarCircle__sGdZZ"};